// Native anchors retain keyboard support; focus the destination after scrolling.
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-kb-scratcher-jump]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = document.getElementById('castle-replacement-scratchers');
  if (!target) return;
  event.preventDefault();
  target.focus({ preventScroll: true });
  target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  history.replaceState(null, '', '#castle-replacement-scratchers');
});

// Mirror native form feedback without changing its cart request or selling plan.
if (!customElements.get('kb-spare-feedback')) customElements.define('kb-spare-feedback', class extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    const source = this.querySelector('[ref="liveRegion"]');
    const status = this.querySelector('[data-spare-confirmation]');
    if (!source || !status) return;
    this.observer = new MutationObserver(() => { if (source.textContent.trim()) status.textContent = source.textContent.trim(); });
    this.observer.observe(source, {subtree:true, childList:true, characterData:true});
  }
  disconnectedCallback() { this.observer?.disconnect(); }
});
